module.exports = (__webpack_require__(5995))(60);